module.exports = __webpack_public_path__ + "img/logo-woco-wbvelsen-white.6d1dabd3.png";